import { RouteConfig } from 'vue-router';

// Modules
import { routes as requestsRoutes } from '@/modules/requests/routes';
import { routes as paymentRoutes } from '@/modules/payment/routes';
import NotFoundPage from '@/pages/NotFound/notFound';

const routes: Array<RouteConfig> = [
  ...paymentRoutes,
  ...requestsRoutes,
  {
    path: '/not-found',
    name: 'NotFound',
    component: NotFoundPage,
  },
  {
    path: '*',
    component: NotFoundPage,
    redirect: {
      path: '/not-found',
    },
  },
];

export default routes;
